import { Component, Injector, OnInit, ViewChild } from "@angular/core";
import { PrincipalService } from "src/app/services/principal.service";
import { Principal } from "src/app/models/principal";
import { Router } from "@angular/router";
import * as firebase from "firebase";
import { AlertComponent } from 'src/app/alert/alert.component';

@Component({
  selector: "app-list-principal",
  templateUrl: "./list-principal.component.html",
  styleUrls: ["./list-principal.component.css"],
})
export class ListPrincipalComponent implements OnInit {
  search: string = "";
  limit: number = 12;
  off: number = 0;
  principals: Principal[] = [];
  sort: string = "asc";
  canShowMore: boolean = false;
  isLoading: boolean = false;

  @ViewChild("alertComponent") alertComponent: AlertComponent;

  constructor(
    private router: Router,
    public principalService: PrincipalService
  ) {}

  ngOnInit() {
    firebase.analytics().logEvent("home_lihat_semua_rekanan_button");

    this.loadPrincipal();
  }

  loadPrincipal() {
    firebase.analytics().logEvent("rekanan_search_button");

    this.isLoading = true;
    this.off = 0;
    this.principalService.getListPrincipal(
      this.search,
      this.limit,
      this.off,
      this.sort,
      (data) => {
        this.isLoading = false;
        this.principals = data;
        if (data.length > 0) {
          this.off += this.limit;
          this.canShowMore = true;
        } else {
          this.canShowMore = false;
        }
      },
      (err) => {
        this.isLoading = false;
        this.alertComponent.show(err.code, err.message);
      }
    );
  }

  showMore() {
    firebase.analytics().logEvent("rekanan_load_more_button");

    this.isLoading = true;
    this.canShowMore = false;

    this.principalService.getListPrincipal(
      this.search,
      this.limit,
      this.off,
      this.sort,
      (data) => {
        this.isLoading = false;
        if (data.length > 0) {
          data.forEach((item) => {
            this.principals.push(item);
          });

          this.canShowMore = true;
        }

        this.off += this.limit;
      },
      (err) => {
        this.isLoading = false;
        this.alertComponent.show(err.code, err.message);
      }
    );
  }

  goToProduct(data: Principal) {
    firebase.analytics().logEvent("rekanan_kunjungi_button");
    this.router.navigate([`/product/principal/${btoa(JSON.stringify(data))}`]);
  }
}
